export const API_BASE = process.env.REACT_APP_API_URL || "https://nyatwende-api-uaoo.onrender.com";

export async function parseJsonResponse(response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
}
